import { stringifyUrl } from './api'
import { $Object } from './object'
import { routes } from '../routes/routes'

export const getRoute = (name: string, params: $Object = {}): string => {
  const route = routes.find((item) => item.name === name)

  if (route) {
    let { path } = route

    Object.keys(params).map(
      (key) => (path = path?.replace(`:${key}`, params[key]))
    )

    return params.query ? stringifyUrl(path ?? '', params.query) : path ?? ''
  }

  return ''
}
